export default __webpack_public_path__ + "static/media/loremipsum.bd1491a8.svg";